import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, message, Input, Select } from "antd";
import AdminRehabCenterTable from "./AdminRehabCenterTable";
import StatusSidebar from "./StatusSidebar";
import { fetchAllRehabCenters } from "../../api/rehabCenter";
import AdminLoginForm from "./AdminLoginForm";
import NavBar from "../Layout/NavBar";

const AdminLogin = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [rehabCenters, setRehabCenters] = useState([]);
  const [statusFilter, setStatusFilter] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOption, setSortOption] = useState("date_added");
  const navigate = useNavigate();

  const loadRehabCenters = async () => {
    const data = await fetchAllRehabCenters();
    setRehabCenters(data);
  };

  useEffect(() => {
    const token = sessionStorage.getItem("adminToken");
    if (token) {
      setIsAuthenticated(true);
    }
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      loadRehabCenters();
    }
  }, [isAuthenticated]);

  const handleLoginSuccess = (token) => {
    sessionStorage.setItem("adminToken", token);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    sessionStorage.removeItem("adminToken");
    setIsAuthenticated(false);
    message.success("You have been logged out.");
    navigate("/adminlogin");
  };

  const filteredRehabCenters = rehabCenters
    .filter((rehabCenter) => {
      const statusMatch =
        statusFilter === "all" ||
        (rehabCenter.status || "").toLowerCase() === statusFilter.toLowerCase();

      const searchMatch =
        !searchTerm ||
        rehabCenter.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (rehabCenter.locality &&
          rehabCenter.locality.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (rehabCenter.city_town &&
          rehabCenter.city_town
            .toLowerCase()
            .includes(searchTerm.toLowerCase())) ||
        (rehabCenter.phone_number &&
          rehabCenter.phone_number.includes(searchTerm));

      return statusMatch && searchMatch;
    })
    .sort((a, b) => {
      if (sortOption === "alphabetical") {
        return a.name.localeCompare(b.name);
      } else {
        // Default sort by date added (assuming created_at field exists)
        return new Date(b.created_at) - new Date(a.created_at);
      }
    });

  if (!isAuthenticated) {
    return (
      <>
        <NavBar
          showNavLinks={false}
          showRegisterButton={false}
          showLogoutButton={false}
        />
        <AdminLoginForm onLoginSuccess={handleLoginSuccess} />
      </>
    );
  }

  return (
    <>
      <NavBar
        showNavLinks={false}
        showRegisterButton={false}
        showLogoutButton={true}
        handleLogout={handleLogout}
      />
      <div style={{ display: "flex" }}>
        <StatusSidebar
          selectedStatus={statusFilter}
          onStatusClick={setStatusFilter}
        />
        <div style={{ flex: 1, padding: "16px" }}>
          <div style={{ marginBottom: "16px", display: "flex", justifyContent: "space-between" }}>
            <Input.Search
              placeholder="Search by name, area, or mobile number"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ width: 400 }}
            />
            <Select
              value={sortOption}
              onChange={setSortOption}
              style={{ width: 200 }}
            >
              <Select.Option value="date_added">Sort by Date Added</Select.Option>
              <Select.Option value="alphabetical">Sort Alphabetically</Select.Option>
            </Select>
          </div>
          <AdminRehabCenterTable
            data={filteredRehabCenters}
            status={statusFilter}
            onStatusUpdated={loadRehabCenters}
          />
        </div>
      </div>
    </>
  );
};

export default AdminLogin;